import { IEnvironment } from './ienvironment';

export const environment: IEnvironment = {
  firebase: {
    apiKey: 'AIzaSyAbkEId-Rr-PBL4_W-QHd1aOgx04WnL8LY',
    authDomain: 'datasafracloud-hmg.firebaseapp.com',
  },
  production: true,
  BACKEND_HOST: window.location.origin,
  QGIS_PATH:
    'https://datasafra-backend-api-gateway-7lijtifl.uc.gateway.dev/qgis',
  MARTIN_HOST: 'datasafra-mvt-server-595383258513.us-central1.run.app',
  MARTIN_PROTOCOL: 'https',
  GOOGLE_API_KEY: 'AIzaSyBsArB0nhCCndSOB5Ielu_e3I05jMx345o', //datasafra
  CONTACT_URL: 'https://conteudo.geoambiente.com.br/pre-lancamento-datasafra',
  agentRuntimeUrl: window.location.origin + '/agent',
};
